import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'App/store';
import {
  fetchShippingRestrictions,
  getShippingRestrictionsData,
  getShippingRestrictionsStatus,
} from '../../deliveryMethodsSlice';

function useGetShippingRestrictions() {
  const dispatch = useAppDispatch();
  const restrictions = useSelector(getShippingRestrictionsData);
  const { isLoading, isError, isSuccess } = useSelector(
    getShippingRestrictionsStatus,
  );

  const fetchRestrictions = useCallback(
    (carrierId: string) => {
      dispatch(fetchShippingRestrictions(carrierId));
    },
    [dispatch],
  );

  return {
    restrictions,
    isLoading,
    isError,
    isSuccess,
    fetchRestrictions,
  };
}

export default useGetShippingRestrictions;
